"use strict";
// Cache key utilities for consistent caching across platform
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCache = exports.CACHE_TTL = exports.CACHE_KEYS = void 0;
exports.CACHE_KEYS = {
    FACT_CHECK: (queryHash) => `fact_check:${queryHash}`,
    USER_LIMITS: (userId) => `limits:${userId}`,
    RATE_LIMIT: (ipAddress) => `rate:${ipAddress}`,
    USER_SESSION: (sessionId) => `session:${sessionId}`,
    SUBSCRIPTION: (userId) => `subscription:${userId}`,
    COMMUNITY_POSTS: (page, limit) => `community:posts:${page}:${limit}`,
    USER_BADGES: (userId) => `badges:${userId}`,
};
exports.CACHE_TTL = {
    FACT_CHECK: 24 * 60 * 60, // 24 hours
    USER_LIMITS: 24 * 60 * 60, // 24 hours (reset daily)
    RATE_LIMIT: 60 * 60, // 1 hour
    USER_SESSION: 60 * 60, // 1 hour
    SUBSCRIPTION: 60 * 60, // 1 hour
    COMMUNITY_POSTS: 5 * 60, // 5 minutes
    USER_BADGES: 60 * 60, // 1 hour
};
// Cache utilities for client-side storage
class ClientCache {
    constructor() {
        this.cache = new Map();
    }
    set(key, data, ttlSeconds = 300) {
        const expires = Date.now() + (ttlSeconds * 1000);
        this.cache.set(key, { data, expires });
    }
    get(key) {
        const item = this.cache.get(key);
        if (!item)
            return null;
        if (Date.now() > item.expires) {
            this.cache.delete(key);
            return null;
        }
        return item.data;
    }
    delete(key) {
        this.cache.delete(key);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
    // Clean expired entries
    cleanup() {
        const now = Date.now();
        for (const [key, item] of this.cache.entries()) {
            if (now > item.expires) {
                this.cache.delete(key);
            }
        }
    }
}
exports.ClientCache = ClientCache;
//# sourceMappingURL=cache.js.map